import { type Dispatch, type SetStateAction, useState } from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Alert from '@mui/material/Alert'

import CustomButton from '@/components/custom-button'
import { useUpdateUserIdAndGenerateQR } from '@/hooks/use-tuya'
import {
    FormControlWithLabelWrapper,
    Hint,
} from '../../../views/wizard/steps/wizard-common'
import { Typography } from '@mui/material'
import QRCodeStatus from './qr-code-status'

export default function QRCodeGeneration({
    setShowGeneration,
}: {
    setShowGeneration?: Dispatch<SetStateAction<boolean>>,
}) {
    
    const [userCode, setUserCode] = useState<string>('')
    const [QRCodeId, setQRCodeId] = useState<string | null>(null)
    const [error, setError] = useState<boolean>(false)
    
    const mutation = useUpdateUserIdAndGenerateQR()

    const handleGenerate = async () => {
        const result = await mutation.runChainedMutations(userCode)
        if (result) {
            setError(false)
            setQRCodeId(result)
        } else {
            setError(true)
            setQRCodeId(result)
        }
        setQRCodeId(result)
        return 1
    }

    return (
        <>
            {error &&
                <Alert severity="error">
                    Nastala chyba při vytváření QR kódu. Zkontrolujte prosím User Code.
                </Alert>
            }
            {QRCodeId ?
                <Box>
                    <Typography
                        component="div"
                        sx={{ fontSize: '1.25rem', color: 'primary.main' }}
                    >
                        QR kód
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <img src={'/api/user/show_qr_code?id='+QRCodeId}/>
                    </Box>
                    <Hint>
                        Přejděte do Tuya aplikace
                        <ul>
                            <li>Me - vpravo nahoře je [-] sken</li>
                            <li>namířit foťák mobilu na QR kód z naší
                                aplikace
                            </li>
                            <li>potvrdit zmáčknutím "Confirm login"</li>
                        </ul>
                    </Hint>
                    <QRCodeStatus setShowGeneration={setShowGeneration}/>
                </Box>
                :
                <FormControlWithLabelWrapper
                    label={'User Code'}
                    labelId="usercode"
                    hint={
                        <>
                            V Tuya aplikaci

                            <ul>
                                <li>najít User Code ( Me - vpravo nahoře
                                    je {"<()>"} → account security → User Code )
                                </li>
                            </ul>

                            <br/>

                            Na zařízení ze kterého se bude skenovat kód:
                            <ul>
                                <li>opsat User Code z Tuya</li>
                                <li>potvrdit "Vytvořit QR kód"</li>
                                <li>vygenerován obrázek QR kódu</li>
                            </ul>

                        </>
                    }
                >
                    <TextField
                        id="usercode"
                        variant="standard"
                        type="text"
                        required value={userCode}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setUserCode(event.target.value)
                        }}
                    />

                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <CustomButton
                            text="Vytvořit QR kód"
                            disabled={!userCode}
                            onClick={() => handleGenerate()}
                        />
                    </Box>
                </FormControlWithLabelWrapper>
            }
        </>
    )
}
